<div class="ir-area ir-mask th-mask" *ngIf="categoriesForm">
  <form class="ir-modal th-modal" (ngSubmit)="save(categoriesForm.value)" [formGroup]="categoriesForm">
    <modal-header [plugin]="plugin" [menuModal]="menuModal"></modal-header>
    <div class="ir-modal--body has-footer ir-pv8 ir-ph8">
      <div class="ir-content--modal th-content">
        <table class="ir-modal-table">
          <tr>
            <td class="margin">
              <h2>
                <span>{{ 'plugins.equipment-info.product-line' | translate }}</span>
              </h2>
            </td>
            <td class="margin-big">
              <div class="ir-form-group">
                <select
                  name="productLineId"
                  class="ir-form-set"
                  formControlName="productLineId"
                  (change)="updateCategories()"
                >
                  <option
                    *ngFor="let productLine of productLines | orderBy : 'name'"
                    [value]="productLine.id"
                    [selected]="productLineId == productLine.id"
                  >
                    {{ productLine.name }}
                  </option>
                </select>
              </div>
            </td>
          </tr>
          <tr *ngIf="showMachineFamilySelector() && !isOptimization">
            <td class="margin">
              <h2>
                <span>{{ 'plugins.equipment-info.machine-family' | translate }}</span>
              </h2>
            </td>
            <td class="margin-big">
              <div class="ir-form-group">
                <select name="categoryId" class="ir-form-set" formControlName="categoryId" (change)="updateMachines()">
                  <option
                    *ngFor="let category of categoriesComboData | orderBy : 'name'"
                    [value]="category.id"
                    [selected]="categoryId == category.id"
                  >
                    {{ category.name }}
                  </option>
                </select>
              </div>
            </td>
          </tr>
          <tr *ngIf="showMachines()">
            <div *ngFor="let m of machinesComboData | orderBy : ['serie', 'name']">
              <h2>
                <span>{{ m.serie }} - {{ m.name }}</span>
              </h2>
            </div>
          </tr>
        </table>
      </div>
    </div>
    <div class="ir-modal--footer ir-position--b th-modal--footer">
      <div class="ir-row">
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <div class="ir-btn ir-btn--big ir-btn--block th-btn-modal ir-txt--left" (click)="cancel()">
            <span>{{ 'common.cancel' | translate }}</span>
          </div>
        </div>
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <button
            class="ir-btn ir-btn--big ir-btn--block th-btn-modal--action ir-txt--right"
            type="submit"
            [disabled]="categoriesForm.invalid"
            *ngIf="!processing"
          >
            <span>{{ 'common.save-changes' | translate }}</span>
          </button>
          <button
            class="ir-btn ir-btn--big ir-btn--block th-btn-disabled ir-txt--right"
            type="submit"
            *ngIf="processing"
          >
            <span>{{ 'common.processing' | translate }}</span>
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
